<template>
  <div class="income-cost-confirm-detail">
    <a-spin :spinning="loading">
      <div class="content flex-ct between" style="min-height: 0">
        <a-tabs default-active-key="BaseInfo" @change="changeTabs">
          <a-tab-pane key="BaseInfo" :tab="$t('基本信息')"></a-tab-pane>
          <a-tab-pane key="DetailInfo" :tab="$t('明细信息')"></a-tab-pane>
        </a-tabs>
        <div class="flex-ct gap10" v-show="!loading">
          <OperateBtn
            v-if="formData.status === 'DRAFT' && isDetail"
            api="operateDoc"
            :text="$t('提交')"
            :params="{
              action: 'commit',
              docType: docType,
              idList: [id],
            }"
            @success="init"
          />
          <OperateBtn
            v-if="formData.status === 'WAIT_CHECK' && isDetail"
            api="operateDoc"
            :text="$t('审核')"
            :params="{
              action: 'check',
              docType: docType,
              idList: [id],
            }"
            @success="init"
          />
          <OperateBtn
            v-if="['DRAFT', 'WAIT_CHECK'].includes(formData.status) && isDetail"
            api="operateDoc"
            type="danger"
            :text="$t('作废')"
            :params="{
              action: 'cancel',
              docType: docType,
              idList: [id],
            }"
            @success="init"
          />
          <FindRelatedDocBtn :id="id" :docType="docType" v-if="isDetail" />
          <VoucherBtn
            v-if="
              isDetail &&
              !['DRAFT', 'WAIT_CHECK', 'CANCELLED'].includes(formData.status) &&
              !formData.voucherGenerated
            "
            :docType="docType"
            :selectedRows="[formData]"
            @close="init"
          />
        </div>
      </div>
      <div class="content-overflow">
        <section class="left-div fixContent" :style="{ height: scrollHeight }">
          <a-form-model ref="ruleForm" :model="formData" :rules="rules">
            <ModalBox id="BaseInfo" :title="$t('基本信息')">
              <a-row :gutter="16">
                <a-col :span="6" v-if="isDetail">
                  <a-form-model-item :label="$t('单据编号')">
                    <a-input disabled v-model="formData.orderSn" />
                  </a-form-model-item>
                </a-col>
                <a-col :span="6" v-if="isDetail">
                  <a-form-model-item :label="$t('状态')">
                    <a-input
                      disabled
                      v-model="incomeCostConfirmOrderStatusMapping[formData.status]"
                    />
                  </a-form-model-item>
                </a-col>
                <a-col :span="6">
                  <a-form-model-item :label="$t('结算组织')" prop="businessUnitCode">
                    <a-input v-if="isDetail" disabled v-model="formData.businessUnitName" />
                    <CommonSelect
                      v-else
                      :isBu="true"
                      :list="$store.state.settlementBuList"
                      :placeholder="$t('请选择结算组织')"
                      :code.sync="formData.businessUnitCode"
                    />
                  </a-form-model-item>
                </a-col>
                <a-col :span="6">
                  <a-form-model-item :label="$t('单据类型')" prop="orderType">
                    <a-input
                      v-if="isDetail"
                      disabled
                      :value="mappings.orderType[formData.orderType] || formData.orderType"
                    />
                    <a-select
                      v-else
                      v-model="formData.orderType"
                      :placeholder="$t('请选择单据类型')"
                      style="width: 100%"
                    >
                      <a-select-option
                        v-for="(name, code) in Object.keys(mappings.orderType || {}).length
                          ? mappings.orderType
                          : incomeCostConfirmOrderTypeMapping"
                        :key="code"
                        :value="code"
                      >
                        {{ name }}
                      </a-select-option>
                    </a-select>
                  </a-form-model-item>
                </a-col>
                <a-col :span="6">
                  <a-form-model-item :label="$t('来源类型')">
                    <a-input
                      v-if="isDetail"
                      disabled
                      :value="mappings.sourceOrderType[formData.sourceType] || formData.sourceType"
                    />
                    <a-select
                      v-else
                      v-model="formData.sourceType"
                      allow-clear
                      :placeholder="$t('请选择来源类型')"
                      style="width: 100%"
                    >
                      <a-select-option
                        v-for="item in $store.state.source_order_type"
                        :key="item.code"
                        :value="item.code"
                      >
                        {{ item.name }}
                      </a-select-option>
                    </a-select>
                  </a-form-model-item>
                </a-col>
                <a-col :span="6">
                  <a-form-model-item :label="$t('来源编码')">
                    <a-input
                      :disabled="isDetail"
                      v-model.trim="formData.sourceCode"
                      :placeholder="$t('请输入来源编码')"
                    />
                  </a-form-model-item>
                </a-col>
                <a-col :span="6">
                  <a-form-model-item :label="$t('来源名称')">
                    <a-input
                      :disabled="isDetail"
                      v-model.trim="formData.sourceName"
                      :placeholder="$t('请输入来源名称')"
                    />
                  </a-form-model-item>
                </a-col>
                <a-col :span="6">
                  <a-form-model-item :label="$t('记账日期')" prop="accountingDate">
                    <DatePicker
                      :needhms="false"
                      style="background-color: #ffffff; width: 100%"
                      :init-date-time="formData.accountingDate"
                      @choose="(d) => (formData.accountingDate = d.data)"
                      :disabled="isDisabled"
                      :placehold="$t('记账日期')"
                    />
                  </a-form-model-item>
                </a-col>
                <a-col :span="6">
                  <a-form-model-item :label="$t('业务时间')">
                    <DatePicker
                      :needhms="true"
                      style="background-color: #ffffff; width: 100%"
                      :init-date-time="formData.bizDate"
                      @choose="(d) => (formData.bizDate = d.data)"
                      :disabled="isDisabled"
                      :placehold="$t('业务时间')"
                    />
                  </a-form-model-item>
                </a-col>
                <a-col :span="6">
                  <a-form-model-item :label="$t('开始日期')">
                    <DatePicker
                      v-if="!isDetail"
                      :needhms="false"
                      style="background-color: #ffffff; width: 100%"
                      :init-date-time="formData.startDate"
                      @choose="(d) => (formData.startDate = d.data)"
                      :placehold="$t('开始日期')"
                    />
                    <a-input
                      v-else
                      disabled
                      :value="
                        formData.startDate ? dayjs(formData.startDate).format('YYYY-MM-DD') : ''
                      "
                    />
                  </a-form-model-item>
                </a-col>
                <a-col :span="6">
                  <a-form-model-item :label="$t('结束日期')">
                    <DatePicker
                      v-if="!isDetail"
                      :needhms="false"
                      style="background-color: #ffffff; width: 100%"
                      :init-date-time="formData.endDate"
                      @choose="(d) => (formData.endDate = d.data)"
                      :placehold="$t('结束日期')"
                    />
                    <a-input
                      v-else
                      disabled
                      :value="formData.endDate ? dayjs(formData.endDate).format('YYYY-MM-DD') : ''"
                    />
                  </a-form-model-item>
                </a-col>
                <a-col :span="6">
                  <a-form-model-item :label="$t('结算货币')">
                    <a-input v-if="isDetail" disabled v-model="formData.settlementCurrency" />
                    <SelectCurrency
                      v-else
                      :code.sync="formData.settlementCurrency"
                      style="width: 100%"
                    />
                  </a-form-model-item>
                </a-col>
                <a-col :span="6">
                  <a-form-model-item :label="$t('本位币')">
                    <a-input v-if="isDetail" disabled v-model="formData.functionalCurrency" />
                    <SelectCurrency
                      v-else
                      :code.sync="formData.functionalCurrency"
                      style="width: 100%"
                    />
                  </a-form-model-item>
                </a-col>
                <a-col :span="6">
                  <a-form-model-item :label="$t('能否生成凭证')">
                    <a-select
                      :disabled="isDisabled"
                      v-model="formData.needGenerateVoucher"
                      style="width: 100%"
                    >
                      <a-select-option :value="1">{{ $t('需要') }}</a-select-option>
                      <a-select-option :value="0">{{ $t('不需要') }}</a-select-option>
                    </a-select>
                  </a-form-model-item>
                </a-col>
                <a-col :span="6">
                  <a-form-model-item :label="$t('总金额')">
                    <PriceInput
                      :value="formData.totalAmount"
                      :currency="formData.settlementCurrency"
                      :showTxt="true"
                    />
                  </a-form-model-item>
                </a-col>
                <a-col :span="6">
                  <a-form-model-item :label="$t('未税金额')">
                    <PriceInput
                      :value="formData.totalAmountWithoutTax"
                      :currency="formData.settlementCurrency"
                      :showTxt="true"
                    />
                  </a-form-model-item>
                </a-col>
                <a-col :span="6">
                  <a-form-model-item :label="$t('税率') + '(%)'">
                    <a-input-number
                      :disabled="isDisabled"
                      v-model="formData.taxRate"
                      :min="0"
                      :max="100"
                      style="width: 100%"
                      @change="calcTaxAmount"
                    />
                  </a-form-model-item>
                </a-col>
                <a-col :span="6">
                  <a-form-model-item :label="$t('税额')">
                    <PriceInput
                      :value="formData.taxAmount"
                      :currency="formData.settlementCurrency"
                      :showTxt="true"
                    />
                  </a-form-model-item>
                </a-col>
                <a-col :span="6" v-if="isDetail">
                  <a-form-model-item :label="$t('是否生成凭证')">
                    <a-input disabled :value="formData.voucherGenerated ? $t('是') : $t('否')" />
                  </a-form-model-item>
                </a-col>
                <a-col :span="6" v-if="isDetail && formData.voucherNo">
                  <a-form-model-item :label="$t('凭证号')">
                    <a-input disabled v-model="formData.voucherNo" />
                  </a-form-model-item>
                </a-col>
                <a-col :span="6">
                  <a-form-model-item :label="$t('收款金额')">
                    <a-input-number
                      :disabled="isDisabled"
                      v-model="formData.receiptAmount"
                      :min="0"
                      style="width: 100%"
                    />
                  </a-form-model-item>
                </a-col>
                <a-col :span="6">
                  <a-form-model-item :label="$t('收款状态')">
                    <a-input
                      :disabled="isDisabled"
                      v-model.trim="formData.receiptStatus"
                      :placeholder="$t('请输入收款状态')"
                    />
                  </a-form-model-item>
                </a-col>
                <a-col :span="6">
                  <a-form-model-item :label="$t('备注')">
                    <a-input
                      v-model="formData.remark"
                      :disabled="isDisabled"
                      :placeholder="$t('备注')"
                    />
                  </a-form-model-item>
                </a-col>
                <a-col :span="6" v-if="isDetail && formData.checkTime">
                  <a-form-model-item :label="$t('审核时间')">
                    <a-input disabled v-model="formData.checkTime" />
                  </a-form-model-item>
                </a-col>
                <a-col :span="6" v-if="isDetail">
                  <a-form-model-item :label="$t('创建时间')">
                    <a-input disabled v-model="formData.createdAt" />
                  </a-form-model-item>
                </a-col>
                <a-col :span="6" v-if="isDetail">
                  <a-form-model-item :label="$t('创建人')">
                    <a-input disabled v-model="formData.createdUser" />
                  </a-form-model-item>
                </a-col>
                <a-col :span="6" v-if="isDetail">
                  <a-form-model-item :label="$t('更新时间')">
                    <a-input disabled v-model="formData.updatedAt" />
                  </a-form-model-item>
                </a-col>
                <a-col :span="6" v-if="isDetail">
                  <a-form-model-item :label="$t('更新人')">
                    <a-input disabled v-model="formData.updatedUser" />
                  </a-form-model-item>
                </a-col>
              </a-row>
            </ModalBox>
          </a-form-model>

          <ModalBox id="DetailInfo" :title="$t('明细信息')">
            <!-- 添加商品工具栏（仅在创建或编辑模式下展示） -->
            <div class="flex-ct mb12" v-if="!isDetail || isEdit">
              <SkuQuickQueryModal style="width: 320px" @selected="handleChangeSku" />
              <a-button type="primary" style="margin-left: 15px" @click="addGoodsToTable">
                <i class="icon iconfont icon-new" style="margin-right: 5px"></i>
                {{ $t('添加') }}
              </a-button>
              <!-- <a-button style="margin-left: 10px" @click="handleAddBlankLine">
                <a-icon type="plus" />
                {{ $t('添加自定义行') }}
              </a-button> -->
            </div>

            <a-table
              :columns="detailColumns"
              :dataSource="formData.detailList || []"
              bordered
              size="middle"
              :pagination="false"
              :rowKey="(record, index) => index"
            >
              <!-- 商品信息 -->
              <template slot="itemInfo" slot-scope="text, record">
                <div v-if="record.itemName || record.gtin">
                  <div v-if="record.itemName">{{ $t('名称') }}: {{ record.itemName }}</div>
                  <div v-if="record.gtin">{{ $t('代码') }}: {{ record.gtin }}</div>
                </div>
                <div v-else-if="!isDetail || isEdit">
                  <a-input
                    v-model="record.itemName"
                    size="small"
                    :placeholder="$t('商品名称')"
                    style="margin-bottom: 4px"
                  />
                  <a-input v-model="record.gtin" size="small" :placeholder="$t('商品代码')" />
                </div>
              </template>

              <!-- 商品数量 -->
              <template slot="quantity" slot-scope="text, record">
                <div v-if="!isDetail || isEdit" class="flex-ct">
                  <a-input-number
                    v-model="record.quantity"
                    size="small"
                    :min="0"
                    style="width: 75px"
                    @change="
                      (val) => {
                        record.rawQuantity = val
                      }
                    "
                  />
                  <span style="margin-left: 4px">
                    {{ record.rawUnit || record.baseUnit || '' }}
                  </span>
                </div>
                <span v-else>{{ text + (record.rawUnit || record.baseUnit || '') }}</span>
              </template>

              <!-- 商品总金额 -->
              <template slot="amount" slot-scope="text, record">
                <a-input-number
                  v-if="!isDetail || isEdit"
                  v-model="record.amount"
                  size="small"
                  style="width: 110px"
                  @change="calcHeaderAmounts"
                />
                <PriceInput
                  v-else
                  :value="text"
                  :showTxt="true"
                  :currency="formData.settlementCurrency"
                />
              </template>

              <!-- 开始日期 -->
              <template slot="startDate" slot-scope="text, record">
                <a-date-picker
                  v-if="!isDetail || isEdit"
                  v-model="record.startDate"
                  valueFormat="YYYY-MM-DD"
                  size="small"
                  style="width: 125px"
                />
                <span v-else>{{ text ? dayjs(text).format('YYYY-MM-DD') : '' }}</span>
              </template>

              <!-- 结束日期 -->
              <template slot="endDate" slot-scope="text, record">
                <a-date-picker
                  v-if="!isDetail || isEdit"
                  v-model="record.endDate"
                  valueFormat="YYYY-MM-DD"
                  size="small"
                  style="width: 125px"
                />
                <span v-else>{{ text ? dayjs(text).format('YYYY-MM-DD') : '' }}</span>
              </template>

              <!-- 备注 -->
              <template slot="remark" slot-scope="text, record">
                <a-input
                  v-if="!isDetail || isEdit"
                  v-model="record.remark"
                  size="small"
                  :placeholder="$t('备注')"
                />
                <span v-else>{{ text }}</span>
              </template>

              <!-- 操作 -->
              <template slot="action" slot-scope="text, record, index">
                <a-button
                  type="link"
                  size="small"
                  style="color: #ff4d4f; padding: 0"
                  @click="handleDeleteDetail(index)"
                >
                  {{ $t('删除') }}
                </a-button>
              </template>
            </a-table>
          </ModalBox>
        </section>
        <OperationLog
          ref="OperationLogRef"
          :scrollHeight="scrollHeight"
          :actionSn="sn"
          :type="docType"
          v-if="isDetail"
        />
      </div>

      <BottomBtns
        :isEdit.sync="isEdit"
        :isDetail="isDetail"
        :draftLoading="draftLoading"
        :saveLoading="saveLoading"
        :status="formData.status"
        @submit="onSubmit"
        @cancel="getDetailInfo"
        @back="backForm"
      />
    </a-spin>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import http from '@/service/axios'
import api from '@/service/api'
import DatePicker from '@component/datePicker'
import BottomBtns from '@component/bottomBtns'
import PriceInput from '@component/priceInput'
import OperationLog from '@component/operationLog'
import CommonSelect from '@component/commonSelect'
import SelectCurrency from '@component/selectCurrency'
import SkuQuickQueryModal from '@component/skuQuickQueryModal'
import { convertKeysToCamelCase, goBack, fetchDocumentMappings } from '@/common'
import debounce from '@/common/debounce'
import dayjs from 'dayjs'

export default {
  name: 'incomeCostConfirmDetail',
  components: {
    DatePicker,
    BottomBtns,
    PriceInput,
    OperationLog,
    CommonSelect,
    SelectCurrency,
    SkuQuickQueryModal,
  },
  data() {
    return {
      id: undefined,
      sn: undefined,
      docType: 'IncomeCostConfirmOrder',
      isDetail: false,
      isEdit: false,
      loading: false,
      draftLoading: false,
      saveLoading: false,
      currentGood: null,
      formData: {
        status: 'DRAFT',
        businessUnitCode: undefined,
        businessUnitName: '',
        orderType: undefined,
        sourceType: '',
        sourceCode: '',
        sourceName: '',
        accountingDate: dayjs().format('YYYY-MM-DD'),
        bizDate: dayjs().format('YYYY-MM-DD HH:mm:ss'),
        startDate: dayjs().format('YYYY-MM-DD'),
        endDate: dayjs().format('YYYY-MM-DD'),
        settlementCurrency: 'CNY',
        functionalCurrency: 'CNY',
        needGenerateVoucher: 1,
        totalAmount: 0,
        totalAmountWithoutTax: 0,
        taxRate: 0,
        taxAmount: 0,
        receiptAmount: 0,
        receiptStatus: '',
        remark: '',
        detailList: [],
      },
      mappings: {
        orderType: {},
        sourceOrderType: {},
      },
      rules: {
        businessUnitCode: [
          { required: true, message: this.$t('请选择结算组织'), trigger: 'change' },
        ],
        orderType: [{ required: true, message: this.$t('请选择单据类型'), trigger: 'change' }],
        accountingDate: [{ required: true, message: this.$t('请选择记账日期'), trigger: 'change' }],
      },
    }
  },
  activated() {
    this.init()
    this.fetchMappings()
  },
  beforeRouteUpdate(to, from, next) {
    Object.assign(this.$data, this.$options.data.call(this))
    this.$nextTick(() => {
      this.init()
    })
    next()
  },
  computed: {
    ...mapGetters([
      'incomeCostConfirmOrderStatusMapping',
      'incomeCostConfirmOrderTypeMapping',
      'sourceOrderTypeMapping',
    ]),
    isDisabled() {
      return this.isDetail && !this.isEdit
    },
    scrollHeight() {
      let height = window.innerHeight - 280
      return height * this.$store.state.rate + 'px'
    },
    detailColumns() {
      const cols = [
        {
          title: '#',
          width: 55,
          align: 'center',
          customRender: (text, record, index) => index + 1,
        },
        {
          title: this.$t('商品信息'),
          dataIndex: 'itemInfo',
          scopedSlots: { customRender: 'itemInfo' },
          width: 200,
        },
        {
          title: this.$t('商品数量'),
          dataIndex: 'quantity',
          scopedSlots: { customRender: 'quantity' },
          width: 120,
        },
        {
          title: this.$t('商品总金额'),
          dataIndex: 'amount',
          scopedSlots: { customRender: 'amount' },
          width: 130,
        },
        {
          title: this.$t('开始日期'),
          dataIndex: 'startDate',
          scopedSlots: { customRender: 'startDate' },
          width: 140,
        },
        {
          title: this.$t('结束日期'),
          dataIndex: 'endDate',
          scopedSlots: { customRender: 'endDate' },
          width: 140,
        },
        {
          title: this.$t('备注'),
          dataIndex: 'remark',
          scopedSlots: { customRender: 'remark' },
          width: 160,
        },
      ]
      if (!this.isDetail || this.isEdit) {
        cols.push({
          title: this.$t('操作'),
          scopedSlots: { customRender: 'action' },
          width: 70,
          align: 'center',
        })
      }
      return cols
    },
  },
  methods: {
    dayjs,
    init() {
      this.isEdit = false
      this.isDetail = false
      if (!this.$route.query.id) {
        // 创建模式
        this.id = undefined
        this.sn = undefined
        this.isDetail = false
        this.isEdit = true
        this.formData = {
          status: 'DRAFT',
          businessUnitCode: undefined,
          businessUnitName: '',
          orderType: undefined,
          sourceType: '',
          sourceCode: '',
          sourceName: '',
          accountingDate: dayjs().format('YYYY-MM-DD'),
          bizDate: dayjs().format('YYYY-MM-DD HH:mm:ss'),
          startDate: dayjs().format('YYYY-MM-DD'),
          endDate: dayjs().format('YYYY-MM-DD'),
          settlementCurrency: 'CNY',
          functionalCurrency: 'CNY',
          needGenerateVoucher: 1,
          totalAmount: 0,
          totalAmountWithoutTax: 0,
          taxRate: 0,
          taxAmount: 0,
          receiptAmount: 0,
          receiptStatus: '',
          remark: '',
          detailList: [],
        }
        this.currentGood = null
      } else {
        this.id = this.$route.query.id
        this.sn = this.$route.query.sn
        this.isDetail = true
        this.$nextTick(() => {
          this.$refs.OperationLogRef && this.$refs.OperationLogRef.queryList()
        })
        this.getDetailInfo()
      }
    },
    changeTabs(value) {
      document.querySelector(`#${value}`).scrollIntoView(true)
    },
    async getDetailInfo() {
      if (!this.id) return
      this.loading = true
      let res = await http({
        url: api.getIncomeCostConfirmDetail,
        type: 'post',
        data: {
          id: this.id,
          orderSn: this.sn,
        },
      })
      let result = convertKeysToCamelCase(res.result)
      this.formData = result
      this.loading = false
    },
    backForm(back = 0) {
      goBack('incomeCostConfirmList', back)
    },
    handleChangeSku(data) {
      const itemStyle = Object.entries(data.selectedSpecs || {})
        .map(([, value]) => value)
        .join(';')
      let procurementUnitItem = data.unitList?.find((item) => item.procurementUnit) || {},
        baseUnitItem = data.unitList?.find((item) => item.baseUnit) || {}
      const rawUnit = procurementUnitItem.unitNameFull || baseUnitItem.unitNameFull || '个'
      const baseUnit = baseUnitItem.unitNameFull || rawUnit || '个'

      this.currentGood = {
        gtin: data.goodsCode,
        itemName: data.goodsName,
        itemStyle,
        itemType: data.goodsType === 'RAW_MATERIAL' ? 'RAW_MATERIAL' : 'FINISH_PRODUCT',
        rawUnit,
        baseUnit,
        quantity: 1,
        rawQuantity: 1,
        amount: Number(data.price || 0),
        cost: 0,
      }
    },
    addGoodsToTable() {
      if (!this.currentGood || !this.currentGood.itemName) {
        return this.$message.warning(this.$t('请先选择商品'))
      }
      const newLine = {
        ...this.currentGood,
        sort: (this.formData.detailList || []).length + 1,
        startDate: this.formData.startDate
          ? dayjs(this.formData.startDate).format('YYYY-MM-DD')
          : dayjs().format('YYYY-MM-DD'),
        endDate: this.formData.endDate
          ? dayjs(this.formData.endDate).format('YYYY-MM-DD')
          : dayjs().format('YYYY-MM-DD'),
        remark: '',
        productBatchNo: '',
        projectType: '',
        receiptAmount: 0,
        receiptStatus: '',
      }
      if (!this.formData.detailList) {
        this.$set(this.formData, 'detailList', [])
      }
      this.formData.detailList.push(newLine)
      this.calcHeaderAmounts()
      this.$message.success(this.$t('添加成功'))
    },
    handleAddBlankLine() {
      const newLine = {
        sort: (this.formData.detailList || []).length + 1,
        itemName: '',
        gtin: '',
        itemStyle: '',
        itemType: '',
        baseUnit: '个',
        rawUnit: '个',
        quantity: 1,
        rawQuantity: 1,
        amount: 0,
        cost: 0,
        startDate: this.formData.startDate
          ? dayjs(this.formData.startDate).format('YYYY-MM-DD')
          : dayjs().format('YYYY-MM-DD'),
        endDate: this.formData.endDate
          ? dayjs(this.formData.endDate).format('YYYY-MM-DD')
          : dayjs().format('YYYY-MM-DD'),
        remark: '',
        productBatchNo: '',
        projectType: '',
        receiptAmount: 0,
        receiptStatus: '',
      }
      if (!this.formData.detailList) {
        this.$set(this.formData, 'detailList', [])
      }
      this.formData.detailList.push(newLine)
      this.calcHeaderAmounts()
    },
    handleDeleteDetail(index) {
      this.formData.detailList.splice(index, 1)
      this.calcHeaderAmounts()
    },
    calcHeaderAmounts() {
      const total = (this.formData.detailList || []).reduce(
        (acc, cur) => acc + (Number(cur.amount) || 0),
        0
      )
      this.formData.totalAmount = Number(total.toFixed(2))
      this.calcTaxAmount()
    },
    calcTaxAmount() {
      const taxRate = Number(this.formData.taxRate) || 0
      const totalAmount = Number(this.formData.totalAmount) || 0
      if (taxRate > 0 && totalAmount !== 0) {
        const withoutTax = Number((totalAmount / (1 + taxRate / 100)).toFixed(2))
        this.formData.totalAmountWithoutTax = withoutTax
        this.formData.taxAmount = Number((totalAmount - withoutTax).toFixed(2))
      } else {
        this.formData.totalAmountWithoutTax = totalAmount
        this.formData.taxAmount = 0
      }
    },
    onSubmit: debounce(async function () {
      if (this.saveLoading) return

      if (!this.isDetail) {
        // 创建模式校验
        let valid = false
        if (this.$refs.ruleForm) {
          this.$refs.ruleForm.validate((v) => {
            valid = v
          })
        }
        if (!valid) return

        if (!this.formData.detailList || this.formData.detailList.length === 0) {
          return this.$message.warning(this.$t('请至少添加一条商品明细'))
        }
        for (let i = 0; i < this.formData.detailList.length; i++) {
          const item = this.formData.detailList[i]
          if (!item.itemName || !item.itemName.trim()) {
            return this.$message.warning(
              `${this.$t('第')} ${i + 1} ${this.$t('行明细请输入商品名称')}`
            )
          }
        }

        this.saveLoading = true
        try {
          const taxRate = Number(this.formData.taxRate) || 0
          const payload = {
            incomeCostConfirm: {
              accountingDate: this.formData.accountingDate || '',
              bizDate: this.formData.bizDate || '',
              businessUnitCode: this.formData.businessUnitCode || '',
              startDate: this.formData.startDate || '',
              endDate: this.formData.endDate || '',
              functionalCurrency: this.formData.functionalCurrency || 'CNY',
              settlementCurrency: this.formData.settlementCurrency || 'CNY',
              needGenerateVoucher: Number(this.formData.needGenerateVoucher) || 0,
              orderType: this.formData.orderType || '',
              receiptAmount: Number(this.formData.receiptAmount) || 0,
              receiptStatus: this.formData.receiptStatus || '',
              remark: this.formData.remark || '',
              sourceCode: this.formData.sourceCode || '',
              sourceName: this.formData.sourceName || '',
              sourceType: this.formData.sourceType || '',
              taxRate,
              detailList: this.formData.detailList.map((row, idx) => {
                const amount = Number(row.amount) || 0
                const amountWithoutTax =
                  taxRate > 0 ? Number((amount / (1 + taxRate / 100)).toFixed(2)) : amount
                const taxAmount = Number((amount - amountWithoutTax).toFixed(2))
                return {
                  amount,
                  amountWithoutTax,
                  baseUnit: row.baseUnit || '',
                  cost: Number(row.cost) || 0,
                  endDate: row.endDate || '',
                  gtin: row.gtin || '',
                  itemName: row.itemName || '',
                  itemStyle: row.itemStyle || '',
                  itemType: row.itemType || '',
                  productBatchNo: row.productBatchNo || '',
                  projectType: row.projectType || '',
                  quantity: Number(row.quantity) || 0,
                  rawQuantity: Number(row.rawQuantity || row.quantity) || 0,
                  rawUnit: row.rawUnit || row.baseUnit || '',
                  receiptAmount: Number(row.receiptAmount) || 0,
                  receiptStatus: row.receiptStatus || '',
                  remark: row.remark || '',
                  sort: idx + 1,
                  startDate: row.startDate || '',
                  taxAmount,
                  taxRate,
                }
              }),
            },
          }

          const res = await http({
            url: api.createIncomeCostConfirm,
            type: 'post',
            data: payload,
          })
          if (res?.success) {
            this.$message.success(this.$t('创建成功'))
            this.backForm()
          }
        } finally {
          this.saveLoading = false
        }
      } else {
        // 编辑保存
        this.saveLoading = true
        try {
          await http({
            url: api.updateIncomeCostConfirm,
            type: 'post',
            data: {
              id: this.id,
              accountingDate: this.formData.accountingDate,
              bizDate: this.formData.bizDate,
              remark: this.formData.remark,
            },
            success: (res) => {
              if (res.success) {
                this.$message.success(this.$t('保存成功'))
                this.init()
              }
            },
          })
        } finally {
          this.saveLoading = false
        }
      }
    }),
    async fetchMappings() {
      this.mappings = await fetchDocumentMappings(this.docType, ['orderType', 'sourceOrderType'])
    },
  },
}
</script>

<style lang="scss" scoped>
.content-overflow {
  width: 100%;
  overflow: auto;
  display: flex;
}
.left-div {
  flex: 1;
}
.fixContent {
  padding-top: 0;
  overflow-y: auto;
  overflow-x: hidden;
  padding-bottom: 0;
}
</style>
